import {
    SET_ZONE_OPTIONS,
    FETCH_ALL_ZONES,
    SET_ALL_ZONES,
    GET_ZONE_PARKING_ASSISTANT_SETTINGS,
    SET_ZONE_PARKING_ASSISTANT_SETTINGS,
    UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
    GET_PARKING_PHOTO_SETTINGS,
    GET_PARKING_PHOTO_SETTINGS_SUCCESS,
    EDIT_PARKING_PHOTO_SETTINGS,
    type ZoneOption,
} from 'src/redux/zone/zone.types'
import { type ParkingAssistantSettings, type Zone } from 'src/api/fm/zones/zones.model'
import { type ParkingPhotoSettings } from 'src/api/fm/tasks/tasks.model'

export type GetZoneAction<T extends ZoneAction['type']> = Extract<ZoneAction, { type: T }>

export type ZoneAction =
    | ReturnType<typeof setZoneOptions>
    | ReturnType<typeof fetchAllZones>
    | ReturnType<typeof setAllZones>
    | ReturnType<typeof getZoneParkingAssistantSettings>
    | ReturnType<typeof setZoneParkingAssistantSettings>
    | ReturnType<typeof updateZoneParkingAssistantSettings>
    | ReturnType<typeof getParkingPhotoSettings>
    | ReturnType<typeof getParkingPhotoSettingsSuccess>
    | ReturnType<typeof editParkingPhotoSettings>

export const setZoneOptions = (zones: ZoneOption[]) => {
    return {
        type: SET_ZONE_OPTIONS,
        payload: zones,
    }
}

export const fetchAllZones = () => ({
    type: FETCH_ALL_ZONES,
})

export const setAllZones = (zones: Zone[]) => ({
    type: SET_ALL_ZONES,
    payload: zones,
})

export const getZoneParkingAssistantSettings = (zoneId: string) => ({
    type: GET_ZONE_PARKING_ASSISTANT_SETTINGS,
    payload: zoneId,
})

export const setZoneParkingAssistantSettings = (settings: ParkingAssistantSettings) => {
    return {
        type: SET_ZONE_PARKING_ASSISTANT_SETTINGS,
        payload: settings,
    }
}

export const updateZoneParkingAssistantSettings = (settings: ParkingAssistantSettings) => {
    return {
        type: UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
        payload: settings,
    }
}

export const getParkingPhotoSettings = (zoneId: string) => ({
    type: GET_PARKING_PHOTO_SETTINGS,
    payload: { zoneId },
})

export const getParkingPhotoSettingsSuccess = (parkingPhotoSettings: ParkingPhotoSettings) => ({
    type: GET_PARKING_PHOTO_SETTINGS_SUCCESS,
    payload: { parkingPhotoSettings },
})

export const editParkingPhotoSettings = (zoneId: string, parkingPhotoSettings: ParkingPhotoSettings) => ({
    type: EDIT_PARKING_PHOTO_SETTINGS,
    payload: { zoneId, parkingPhotoSettings },
})
